import React, { useEffect } from 'react';
import { useFileContext } from '../../../../Contexts/FileContext';
import pdfIcon from "./../../../../assets/images/pdf.png";
import { WebApiURL } from '../../../../Constants/Constants';
import CryptoJS from "crypto-js";
import { encryptFileIdValue } from "../../../../utils/encryption";


function FormsNavalArchitectureFormTab() {
  const {
    setComponentName,
    documents,
    loading,
    setSection
  } = useFileContext();

  useEffect(() => {
    setComponentName("Naval Architecture Form");
    setSection("");
  }, [setComponentName]);
  const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
  const secretKey = "MySAMSASecretKey2025"; // same as backend

  const encryptFileId = (fileId) => {
    const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
    return encodeURIComponent(ciphertext);
  };
  const groupedDocs = documents.reduce((acc, doc) => {
    const folder = doc.folderName || 'Uncategorized';
    if (!acc[folder]) acc[folder] = [];
    acc[folder].push(doc);
    return acc;
  }, {});

  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        FORMS
        <span className="text-orange-ef3e33 font-400"> Naval Architecture Form</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4">
        <div className="col-md-8">
          <p className="text-primary-green">
            PLEASE NOTE: “Should the form show a “Please Wait…" ERROR MESSAGE, save/download the form to your device (desktop, laptop or phone) and open the form from there and not via your web browser”
          </p>
        </div>

        <div className="col-12">
          {loading ? (
            <div>Loading documents...</div>
          ) : (
            <ul className="strip-ul mt-3">
              {Object.entries(groupedDocs).map(([folderName, docs], index) => (
                <li className="bg-transparent p-0" key={index}>
                  <div className="row g-4">
                    <div className="col-auto">
                      <img src={pdfIcon} alt="PDF icon" />
                    </div>
                    <div className="col">
                      <div className="row g-4">
                        <div className="col-md">
                          <div className="font-18 font-600">File Name</div>
                          <div className="font-16 font-400">
                            <p className="text-orange-ef3e33 text-uppercase">{folderName}</p>
                            <ul className="list">
                              {docs.map((item, i) => (
                                <li key={i}>
                                  {/* <a
                                    href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item.fileName}
                                  </a> */}
                                  <a
                                    href={`${WebApiURL}File/view/${encryptFileIdValue(item.fileId)}`}
                                    //href={`${WebApiURL}File/view/${encodeBase64(item.fileId.toString())}`}
                                    // target="_blank"
                                    rel="noopener noreferrer"
                                  >{item.fileName}</a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        {/* <div className="col-md-auto">
                          <div className="font-18 font-600">Modified</div>
                          <div className="font-16 font-400">
                            {docs[0]?.modifiedDate
                              ? new Date(docs[0].modifiedDate).toLocaleString()
                              : '—'}
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
}

export default FormsNavalArchitectureFormTab;
